let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lPUcx")).then(() => parcelRequire('6VJF5'));